const Money = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5_1189)">
      <path
        d="M14.1885 12.6723H2.1859C2.05326 12.6723 1.92606 12.6196 1.83227 12.5258C1.73848 12.432 1.68579 12.3048 1.68579 12.1722C1.68579 12.0396 1.73848 11.9124 1.83227 11.8186C1.92606 11.7248 2.05326 11.6721 2.1859 11.6721H14.1885C14.3212 11.6721 14.4484 11.7248 14.5421 11.8186C14.6359 11.9124 14.6886 12.0396 14.6886 12.1722C14.6886 12.3048 14.6359 12.432 14.5421 12.5258C14.4484 12.6196 14.3212 12.6723 14.1885 12.6723Z"
        fill="black"
      />
      <path
        d="M13.1873 14.1725H3.18517C3.05253 14.1725 2.92533 14.1198 2.83154 14.026C2.73775 13.9322 2.68506 13.805 2.68506 13.6724C2.68506 13.5397 2.73775 13.4125 2.83154 13.3187C2.92533 13.2249 3.05253 13.1722 3.18517 13.1722H13.1873C13.32 13.1722 13.4472 13.2249 13.541 13.3187C13.6348 13.4125 13.6875 13.5397 13.6875 13.6724C13.6875 13.805 13.6348 13.9322 13.541 14.026C13.4472 14.1198 13.32 14.1725 13.1873 14.1725Z"
        fill="black"
      />
      <path
        d="M1.18651 8.67154H0.686035V10.173C0.686035 10.4384 0.791493 10.693 0.979208 10.8808C1.16692 11.0685 1.42152 11.1739 1.68699 11.1739H3.18842V10.6734C3.18784 10.1427 2.97674 9.63383 2.60143 9.25852C2.22613 8.88322 1.71727 8.67212 1.18651 8.67154V8.67154Z"
        fill="black"
      />
      <path
        d="M15.1892 7.67158H15.6893V5.67114H15.1892C14.3936 5.67023 13.631 5.3538 13.0684 4.79127C12.5059 4.22873 12.1894 3.46603 12.1885 2.67049V2.17038H4.1868V2.67049C4.18589 3.46603 3.86946 4.22873 3.30692 4.79127C2.74439 5.3538 1.98169 5.67023 1.18614 5.67114H0.686035V7.67158C0.842319 7.67158 1.00923 7.67158 1.18614 7.67158C1.98169 7.67249 2.74439 7.98892 3.30692 8.55145C3.86946 9.11399 4.18589 9.87669 4.1868 10.6722V11.1723H12.1885V10.6722C12.1894 9.87669 12.5059 9.11399 13.0684 8.55145C13.631 7.98892 14.3936 7.67249 15.1892 7.67158V7.67158ZM8.18767 9.67201C7.5942 9.67201 7.01405 9.49603 6.52059 9.16631C6.02714 8.83659 5.64254 8.36796 5.41543 7.81966C5.18831 7.27136 5.12889 6.66803 5.24467 6.08596C5.36045 5.50389 5.64624 4.96923 6.06589 4.54958C6.48554 4.12993 7.0202 3.84414 7.60227 3.72836C8.18434 3.61258 8.78767 3.672 9.33597 3.89912C9.88427 4.12623 10.3529 4.51083 10.6826 5.00429C11.0123 5.49774 11.1883 6.07789 11.1883 6.67136C11.1874 7.4669 10.871 8.2296 10.3084 8.79214C9.74591 9.35467 8.98321 9.6711 8.18767 9.67201V9.67201Z"
        fill="black"
      />
      <path
        d="M8.18749 8.67219C9.29246 8.67219 10.1882 7.77643 10.1882 6.67147C10.1882 5.5665 9.29246 4.67075 8.18749 4.67075C7.08252 4.67075 6.18677 5.5665 6.18677 6.67147C6.18677 7.77643 7.08252 8.67219 8.18749 8.67219Z"
        fill="black"
      />
      <path
        d="M13.1877 10.6734V11.1739H14.6892C14.9546 11.1739 15.2092 11.0685 15.397 10.8808C15.5847 10.693 15.6901 10.4384 15.6901 10.173V8.67154H15.1897C14.6589 8.67212 14.15 8.88322 13.7747 9.25852C13.3994 9.63383 13.1883 10.1427 13.1877 10.6734Z"
        fill="black"
      />
      <path
        d="M15.1897 4.67276H15.6901V3.17133C15.6901 2.90586 15.5847 2.65127 15.397 2.46355C15.2092 2.27584 14.9546 2.17038 14.6892 2.17038H13.1877V2.67086C13.1883 3.20162 13.3994 3.71047 13.7747 4.08578C14.15 4.46108 14.6589 4.67218 15.1897 4.67276V4.67276Z"
        fill="black"
      />
      <path
        d="M3.18842 2.67086V2.17038H1.68699C1.42152 2.17038 1.16692 2.27584 0.979208 2.46355C0.791493 2.65127 0.686035 2.90586 0.686035 3.17133V4.67276H1.18651C1.71727 4.67218 2.22613 4.46108 2.60143 4.08578C2.97674 3.71047 3.18784 3.20162 3.18842 2.67086V2.67086Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1189">
        <rect
          width="16.0035"
          height="16.0035"
          fill="white"
          transform="translate(0.18457 0.169373)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default Money;
